import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LoadingSpinner from '../ui/LoadingSpinner';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { isAuthenticated, user, isLoading, hasRole } = useAuth();
  const location = useLocation();

  // Show loading spinner while checking authentication
  if (isLoading) {
    return <LoadingSpinner text="Checking authentication..." />;
  }

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return (
      <Navigate 
        to="/admin/login" 
        state={{ from: location }} 
        replace 
      />
    );
  }

  // If specific roles are required, check user role
  if (allowedRoles.length > 0) {
    const hasRequiredRole = allowedRoles.some(role => hasRole(role));
    
    if (!hasRequiredRole) {
      return (
        <div className="container py-5">
          <div className="text-center">
            <h2 className="text-danger mb-3">Access Denied</h2>
            <p className="text-muted mb-4">
              You don't have permission to access this page.
            </p>
            <p className="text-sm text-muted">
              Required roles: {allowedRoles.join(', ')}
              <br />
              Your role: {user?.role || 'Unknown'}
            </p>
            <div className="mt-4">
              <Navigate to="/admin/dashboard" replace />
            </div>
          </div>
        </div>
      );
    }
  }

  // User is authenticated and has required permissions
  return children;
};

export default ProtectedRoute;
